module.exports = __webpack_public_path__ + "img/blis1.e6eb0e13.png";